import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import MagnetCursor from "../components/MagnetCursor";
import WorkProcessSection from "../components/WorkProcessSection";
import AboutSection from "../components/Home/AboutSection";

const ABOUT_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_about_us";
const TEAM_API  = "https://backenddev.aaerlaw.com/api/user/team_members";
const SERVER    = "https://backenddev.aaerlaw.com";

function stripHtml(html) {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

function AboutUs() {
  const [aboutData, setAboutData] = useState(null);
  const [members, setMembers]     = useState([]);
  const [teamLoading, setTeamLoading] = useState(true);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";

    // Fetch About Us content
    fetch(ABOUT_API)
      .then((r) => r.json())
      .then((json) => setAboutData(json))
      .catch(() => {});

    // Fetch team members
    fetch(`${TEAM_API}?page=1&limit=50`)
      .then((r) => r.json())
      .then((json) => {
        if (Array.isArray(json?.data)) setMembers(json.data);
      })
      .catch(() => {})
      .finally(() => setTeamLoading(false));
  }, []);

  const fullName = (m) =>
    [m.title, m.first_name, m.middle_name, m.last_name].filter(Boolean).join(" ");

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section — height reduced ~60% via compact padding */}
      <div
        className="breadcrumb-section bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{
          backgroundImage: "url('assets/img/bg-img/73.jpg')",
          paddingTop: "3rem",
          paddingBottom: "3rem",
          minHeight: "unset",
        }}
      >
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              About Us
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </div>

      {/* About Section */}
      <AboutSection />

      {/* Vision & Mission — shown when data is available */}
      {aboutData && (aboutData.vision || aboutData.mission) && (
        <section className="bg-secondary">
          <div className="divider"></div>
          <div className="container">
            <div className="row g-4">
              {aboutData.vision && (
                <div className="col-12 col-md-6">
                  <div className="p-4 h-100" style={{ background: "#fff", borderRadius: "8px" }}>
                    <h4 className="mb-3">Our Vision</h4>
                    <p className="mb-0" style={{ lineHeight: "1.8" }}>
                      {stripHtml(aboutData.vision)}
                    </p>
                  </div>
                </div>
              )}
              {aboutData.mission && (
                <div className="col-12 col-md-6">
                  <div className="p-4 h-100" style={{ background: "#fff", borderRadius: "8px" }}>
                    <h4 className="mb-3">Our Mission</h4>
                    <p className="mb-0" style={{ lineHeight: "1.8" }}>
                      {stripHtml(aboutData.mission)}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="divider"></div>
        </section>
      )}

      {/* Work Process Section */}
      <WorkProcessSection />

      {/* Team Members Section — dynamic */}
      <section className="lawyers-team-section about-team-grid bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-7 col-xl-6">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Team
                </div>
                <h2>Exceptional Legal Team for Your Success</h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center g-4">
            {teamLoading ? (
              <div className="col-12 text-center py-4">
                <div className="spinner-border text-secondary" role="status">
                  <span className="visually-hidden">Loading&hellip;</span>
                </div>
              </div>
            ) : members.length === 0 ? null : (
              members.map((m) => (
                <div key={m.id} className="col-12 col-sm-6 col-md-4">
                  <Link
                    to={`/teamdetails?id=${m.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="laywer-card">
                      <img
                        src={
                          m.profile_image
                            ? `${SERVER}/${m.profile_image}`
                            : "assets/img/bg-img/10.jpg"
                        }
                        alt={fullName(m)}
                      />
                      <div className="laywer-info text-center">
                        <div className="laywer-name">{fullName(m)}</div>
                        <div className="laywer-position">{m.position}</div>
                        <Link
                          to={`/teamdetails?id=${m.id}`}
                          className="btn btn-sm btn-primary mt-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          View Profile
                        </Link>
                      </div>
                      <div className="hover-laywer-info text-center">
                        <div className="laywer-name">{fullName(m)}</div>
                        <div className="laywer-position">{m.position}</div>
                        <div className="social-nav">
                          {m.linkedin && (
                            <a
                              href={m.linkedin}
                              target="_blank"
                              rel="noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i className="ti ti-brand-linkedin"></i>
                            </a>
                          )}
                          {m.twitter && (
                            <a
                              href={m.twitter}
                              target="_blank"
                              rel="noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i className="ti ti-brand-x"></i>
                            </a>
                          )}
                        </div>
                        <Link
                          to={`/teamdetails?id=${m.id}`}
                          className="btn btn-sm btn-primary mt-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          View Profile
                        </Link>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="divider"></div>
      </section>

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default AboutUs;
